
import { supabase } from "@/integrations/supabase/client";

// Like a technique
export const likeTechnique = async (techniqueId: string): Promise<void> => {
  try {
    const { error } = await supabase
      .from('technique_likes')
      .insert({
        technique_id: techniqueId,
        user_id: (await supabase.auth.getUser()).data.user?.id
      });
      
    if (error) {
      console.error('Error liking technique:', error);
      throw new Error(error.message);
    }
  } catch (error: unknown) {
    console.error('Unexpected error in likeTechnique:', error);
    throw error instanceof Error
      ? error
      : new Error('An unexpected error occurred while liking the technique');
  }
};

// Check if a user has already liked a technique
export const checkIfTechniqueIsLiked = async (techniqueId: string): Promise<boolean> => {
  try {
    const { data: userData, error: userError } = await supabase.auth.getUser();
    
    if (userError || !userData.user) {
      return false;
    }

    const { data, error } = await supabase
      .from('technique_likes')
      .select('id')
      .eq('technique_id', techniqueId)
      .eq('user_id', userData.user.id)
      .maybeSingle();
      
    if (error) {
      console.error('Error checking liked technique:', error);
      return false;
    }
    
    return !!data;
  } catch (error: unknown) {
    console.error('Unexpected error in checkIfTechniqueIsLiked:', error);
    return false;
  }
};

// Unlike a technique
export const unlikeTechnique = async (techniqueId: string): Promise<void> => {
  try {
    const { data: userData, error: userError } = await supabase.auth.getUser();
    
    if (userError || !userData.user) {
      throw new Error('You must be logged in to unlike a technique');
    }

    const { error } = await supabase
      .from('technique_likes')
      .delete()
      .eq('technique_id', techniqueId)
      .eq('user_id', userData.user.id);
      
    if (error) {
      console.error('Error unliking technique:', error);
      throw new Error(error.message);
    }
  } catch (error: unknown) {
    console.error('Unexpected error in unlikeTechnique:', error);
    throw error instanceof Error
      ? error
      : new Error('An unexpected error occurred while unliking the technique');
  }
};

// Get technique like count
export const getTechniqueLikeCount = async (techniqueId: string): Promise<number> => {
  try {
    const { data, error } = await supabase
      .from('technique_like_counts')
      .select('like_count')
      .eq('technique_id', techniqueId)
      .maybeSingle();
      
    if (error) {
      console.error('Error getting technique like count:', error);
      return 0;
    }
    
    return data?.like_count || 0;
  } catch (error: unknown) {
    console.error('Unexpected error in getTechniqueLikeCount:', error);
    return 0;
  }
};
